import { api } from '@/lib/api'
import type {
  ContactQueryDetailResponse,
  ContactQueryReply,
  ContactSalesPayload,
  ContactSalesResponse,
  MyContactMessagesResponse,
} from './types'

export const contactSalesApi = {
  send: (payload: ContactSalesPayload) =>
    api.post<ContactSalesResponse>('/api/subscriptions/contact-sales', payload),
  myList: (params: { limit?: number; offset?: number } = {}) =>
    api.get<MyContactMessagesResponse>('/api/subscriptions/my-contact-messages', {
      query: { limit: params.limit ?? 100, offset: params.offset ?? 0 },
    }),
  myGet: (id: number) =>
    api.get<ContactQueryDetailResponse>(`/api/subscriptions/my-contact-messages/${id}`),
  myReply: (id: number, body: string) =>
    api.post<{ reply: ContactQueryReply }>(
      `/api/subscriptions/my-contact-messages/${id}/replies`,
      { body },
    ),
  myClose: (id: number) =>
    api.post<ContactQueryDetailResponse>(`/api/subscriptions/my-contact-messages/${id}/close`),
  myReopen: (id: number) =>
    api.post<ContactQueryDetailResponse>(`/api/subscriptions/my-contact-messages/${id}/reopen`),
}
